module.exports = __webpack_public_path__ + "static/media/3.da306cae.JPG";